import { createBrowserRouter } from 'react-router-dom';

import MainLayout from '@/admin/layouts/MainLayout/MainLayout';
import App from '@/admin/App';
import StyleGuide from '@/admin/components/StyleGuide/StyleGuide';
import CreateDealPage from '@/components/school-management/Form/CreateDealPage/CreateDealPage';
import LoginPage from '@/admin/pages/login/LoginPage';
import DealsListPage from '@/admin/components/DealsListPage/DealsListPage';
import AccountDetailsPage from '@/admin/components/AccountDetailsPage/AccountDetailsPage';
import SchoolsListPage from '@/admin/components/SchoolsListPage/SchoolsListPage';
import SchoolDetailsPage from '@/admin/components/SchoolsListPage/SchoolDetailsPage';
import DistrictsListPage from '@/admin/components/DistrictsListPage/DistrictsListPage';
import DistrictDetailsPage from '@/admin/components/DistrictsListPage/DistrictDetailsPage';
import EditDistrictFormPage from '@/admin/components/DistrictsListPage/EditDistrictFormPage';
import EditAccountFormPage from '@/admin/components/AccountDetailsPage/EditAccountFormPage';
import HistoryPage from '@/admin/components/history/HistoryPage';
import EditTeacherFormPage from '@/admin/components/SchoolsListPage/SchoolDetailsPage/EditTeacherFormPage';
import CreateTeacherFormPage from '@/admin/components/SchoolsListPage/SchoolDetailsPage/CreateTeacherFormPage';
import CreateClassFormPage from '@/admin/components/SchoolsListPage/SchoolDetailsPage/CreateClassFormPage';
import EditClassFormPage from '@/components/school-management/SchoolDetailsPage/EditClassFormPage';
import ViewClassPage from '@/admin/components/SchoolsListPage/SchoolDetailsPage/ViewClassPage';
import StatesListPage from '@/admin/components/StatesListPage/StatesListPage';
import RegionsListPage from '@/admin/components/RegionsListPage/RegionsListPage';
import RouterError from '@/admin/pages/router-error/RouterError';
import { ROUTES } from '@/admin/config/routes';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <RouterError />,
    children: [
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: '/',
        element: <MainLayout />,
        children: [
          {
            path: 'schools',
            element: <SchoolsListPage />,
          },
          {
            path: 'schools/:schoolId/create-class',
            element: <CreateClassFormPage />,
          },
          {
            path: 'schools/:schoolId/edit-class/:classId',
            element: <EditClassFormPage />,
          },
          {
            path: 'schools/:schoolId/class/:classId',
            element: <ViewClassPage />,
          },
          {
            path: 'schools/:schoolId/create-teacher',
            element: <CreateTeacherFormPage />,
          },
          {
            path: 'schools/:schoolId/edit-teacher/:teacherId',
            element: <EditTeacherFormPage />,
          },
          {
            path: 'schools/:schoolId',
            element: <SchoolDetailsPage />,
          },
        ],
      },
    ],
  },
]);

export default router;
